<template>
    <div>
        <el-card class="box-card mb20">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/newsList' }">消息列表</el-breadcrumb-item>
                <el-breadcrumb-item>消息发布</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>

        <el-card class="box-card">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="news-form">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="ruleForm.title"></el-input>
                </el-form-item>

                <el-form-item label="选择机构" prop="">
                    <el-select
                            v-model="ruleForm.agentIdList"
                            multiple
                            clearable
                            collapse-tags
                            @change="agentIdChange"
                            placeholder="请选择">
                        <el-option
                                v-for="item in regionArray"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="角色" prop="">
                    <el-select v-model="ruleForm.agentRoleIdList" :disabled="agentIdChange.length>1" multiple clearable collapse-tags placeholder="请选择">
                        <el-option
                            v-for="item in AgentRoleInfoList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="公告类型" prop="">
                    <el-select v-model="ruleForm.sendDest" clearable placeholder="请选择">
                        <el-option
                            v-for="item in noticeType"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="弹框推送" prop="isSend">
                    <el-switch v-model="ruleForm.isSend"
                               :active-value="0"
                               :inactive-value="1"
                    ></el-switch>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <quill-editor ref="quillEditor"
                                  v-model="ruleForm.content" class="addQuillEditor"
                                  :options="editorOption"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>

            </el-form>
        </el-card>
    </div>


</template>

<script>

    import {quillEditor} from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import quillConfig from '../../upload/quill-config'
    import {ImageDrop} from 'quill-image-drop-module'
    import ImageResize from 'quill-image-resize-module'

    Quill.register('modules/imageDrop', ImageDrop);
    Quill.register('modules/imageResize', ImageResize);
    export default {
        components: {
            quillEditor,
            quillConfig
        },
        name: "send-news",
        props:{
            rowForm:Object

        },
        data(){
            return {
                editorOption: quillConfig,
                ruleForm:{
                    title:"",
                    content:"",
                    agentIdList:[],
                    isSend:1,
                    sendDest:'',
                    agentRoleIdList: []
                },
                regionArray:[],
                AgentRoleInfoList: [],
                noticeType:[{
                    id: 1,
                    name: '机构'
                }, {
                    id: 2,
                    name: 'miniApp'
                }],
                rules:{
                    title: [
                        { required: true, message: '请输入标题', trigger: 'blur' },
                        { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
                    ],
                    content: [
                        { required: true, message: '请输入内容', trigger: 'blur' },
                    ],

                }
            }
        },
        created(){
            this.api.newsCenter
                    .getAgentInfoList()
                    .then(result => {
                        if (result.success) {
                            this.regionArray = result.data;
                            // this.regionArray.unshift({
                            //     id:'11',
                            //     name:'全部'
                            // });
                        } else {
                            this.$message.error(result.message);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            this.getAgentRoleInfoList()
            if(this.rowForm!= undefined){
                this.ruleForm = this.rowForm;
            }
        },
        methods:{
            // 机构idchange
            agentIdChange() {
                if(this.agentIdList.length > 1) {
                    this.AgentRoleInfoList = []
                }
            },
            // 获取角色列表
            getAgentRoleInfoList() {
                this.api.notice
                    .getAgentRoleInfoList()
                    .then(result => {
                        if (result.success) {
                            this.AgentRoleInfoList = result.data;
                        } else {
                            this.$message.error(result.message);
                        }
                    })
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.api.newsCenter
                                .addNotice(this.ruleForm)
                                .then(result => {
                                    if (result.success) {
                                        this.$message.success(result.message);
                                        // this.$refs[formName].resetFields();
                                        this.$router.push({
                                            path: "/newsList"
                                        })
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(error => {
                                    console.log(error);
                                });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="less">
    .news-form {
        width: 80%;
        .addQuillEditor .ql-editor {
            height: 500px;
        }

    }
    .mb20 {
        margin-bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/newsCenter/sendNews.vue